<template>
    <div id="app"
         class="bg-blue-lighter">
         <!-- <ThankYou :booking-data="bookingData"
                  :init-data="initData" /> -->
        <Booking v-if="!isBookingComplete"
                 @bookingCompleted="bookingCompleted"
                 :init-data="initData" />
        <ThankYou v-else
                  :booking-data="bookingData"
                  :init-data="initData" />
    </div>
</template>

<script>
import axios from "axios";
import Booking from "./components/Booking.vue";
import ThankYou from "./components/ThankYou.vue";
import { INITIAL_DATA_URL } from "./constants/urls.js";

export default {
    name: "App",

    components: {
        Booking,
        ThankYou,
    },

    data() {
        return {
            isBookingComplete: false,
            bookingData: {},
            initData: {},
        };
    },

    methods: {
        getInitialData() {
            let m = (new URLSearchParams(location.search)).get('m');
            let org = (new URLSearchParams(location.search)).get('org');
            let campaign = (new URLSearchParams(location.search)).get('campaign');

            axios.post(INITIAL_DATA_URL + `?m=${m}&org=${org}&campaign=${campaign}`)
                .then(response => {
                    this.initData = response.data;
                    this.setFavicon();

                    if (response.data.webinar) {
                        document.title = response.data.webinar.title;
                    } else {
                        document.title = 'Trial Booking - ' + response.data.productName;
                    }
                });
        },

        setFavicon() {
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = `/${this.initData.favicon}`;
            document.getElementsByTagName('head')[0].appendChild(link);
        },

        bookingCompleted(bookingData) {
            this.isBookingComplete = true;
            this.bookingData = bookingData;
        },
    },

    mounted() {
        this.getInitialData();
    }
};
</script>
<style src="./assets/css/tailwind.css">

</style>


